module.exports = __webpack_public_path__ + "static/media/svt_texas.0ad6de1d.png";